import Model, { attr } from '@ember-data/model';

export default class AssignmentRuleCandidateModel extends Model {
  @attr('string') name!: string;
  @attr('string') source!: 'explicit' | 'derived' | 'invited';
  @attr('date') invitedAt!: Date | null;
  @attr('number') offersReceived!: number;
  @attr('number') offersAccepted!: number;
  @attr('number') averageOnSiteMinutes!: number | null;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'assignment-rule-candidate': AssignmentRuleCandidateModel;
  }
}
